import { Vector3, Color } from 'three';

export const CM = 1; // centimeter is the base unit
export const METER = 100;
export const KM = 1000 * METER;

export const AXES = Object.freeze({
  X: new Vector3(1, 0, 0),
  Y: new Vector3(0, 1, 0),
  Z: new Vector3(0, 0, 1),
});

export const AXES_COLORS = Object.freeze({
  X: new Color(0, 0, 1),
  Y: new Color(0, 1, 0),
  Z: new Color(1, 0, 0),
});

export const BASE_SIZE = 20;
export const GRID_SIZE: number = 1000 * METER;


export enum KeyCodes { Esc = 27, Delete = 46, BackSpace = 8 }

/**
 * Due to limitations of the OpenGL Core Profile with the WebGL renderer on
 * most platforms linewidth will always be 1 regardless of the set value.
 * https://threejs.org/docs/#api/en/materials/LineBasicMaterial.linewidth
 */
export const LINE_WIDTH = 1;
